export default __webpack_public_path__ + "static/media/profit.1f526b3c.wav";